import { api } from "./client";

export interface FirmwareRelease {
  id: string;
  version: string;
  applies_to_model: string;
  is_published: boolean;
  released_at: string;
  release_notes: string | null;
  sha256: string | null;
}

export const firmwareApi = {
  list: (model?: string, published?: boolean) => {
    const params = new URLSearchParams();
    if (model !== undefined) params.set("model", model);
    if (published !== undefined) params.set("published", String(published));
    const q = params.toString();
    return api.get<{ releases: FirmwareRelease[] }>(
      `/api/admin/firmware/releases${q ? `?${q}` : ""}`,
    );
  },
  setPublished: (releaseId: string, isPublished: boolean) =>
    api.patch<FirmwareRelease>(
      `/api/admin/firmware/releases/${releaseId}`,
      { is_published: isPublished },
    ),
};
